import React, { createContext, useState } from "react";
import { ConfigProvider, theme } from "antd";
import { useLocalStorage } from "../hooks/useLocalStorage";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem("isAuth") === "true";
  });
  const [hasSettingsAccess, setHasSettingsAccess] = useLocalStorage(
      "hasSettingAccess",
      false
    );
  const [isDark, setIsDark] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [userSession, setUserSession] = useLocalStorage("session", null);
  const [levelOneOptions, setLevelOneOptions] = useLocalStorage("levelOne", null);
  const [levelTwoOptions, setLevelTwoOptions] = useLocalStorage("levelTwo", null);

  const login = () => {
    localStorage.setItem("isAuth", "true");
    setIsAuthenticated(true);
  };

  const logout = () => {
    //localStorage.removeItem("isAuth");
    localStorage.clear();
    setIsAuthenticated(false);
  };

  const toggleTheme = () => setIsDark(!isDark);

  const customTheme = {
    algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
    token: {
      colorPrimary: isDark ? "#fafafa" : "#255B37",
      borderRadius: 6,

      ...(isDark && {
        colorBgBase: "#0a0a0a",
        colorBgContainer: "#171717",
        colorBorder: "#262626",
        colorTextBase: "#e5e5e5"
      })
    },
    components: {
      Tooltip: {
        colorBgDefault: "#255B37"
      },
      Layout: {
        siderBg: isDark ? "#111111" : undefined,
        headerBg: isDark ? "#111111" : undefined
      },
      Menu: {
        itemSelectedColor: isDark ? "#000000" : "#ffffff",
        itemSelectedBg: isDark ? "#f4f4f5" : "#255B37",

        itemHoverColor: isDark ? "#000000" : "#ffffff",
        itemHoverBg: isDark ? "#f4f4f5" : "#64A70A",

        itemHeight: 40,
        itemMarginInline: 8
      },
      itemHeightTable: {
        headerBg: isDark ? "#1a1a1a" : undefined,
        headerColor: isDark ? "#a3a3a3" : undefined,
        rowHoverBg: isDark ? "#1f1f1f" : undefined
      }
    }
  };

  const toggleSidebar = () => setCollapsed(!collapsed);

  return (
    <AppContext.Provider
      value={{
        isAuthenticated,
        login,
        logout,
        isDark,
        toggleTheme,
        setIsDark,
        hasSettingsAccess,
        setHasSettingsAccess,
        collapsed,
        toggleSidebar,
        userSession,
        setUserSession,
        levelOneOptions,
        setLevelOneOptions,
        levelTwoOptions,
        setLevelTwoOptions
      }}
    >
      <ConfigProvider theme={customTheme}>{children}</ConfigProvider>
    </AppContext.Provider>
  );
};
